// Backend balesin status.message kadang string, kadang { field: { rule: teks } }.

function collectTexts(rules) {
  if (typeof rules === 'string') return rules.trim() ? [rules.trim()] : [];
  if (!rules || typeof rules !== 'object') return [];
  return Object.values(rules)
    .filter((text) => typeof text === 'string' && text.trim())
    .map((text) => text.trim());
}

export function validationText(message) {
  if (message === null || message === undefined) return '';
  if (typeof message === 'string') return message.trim();
  if (typeof message !== 'object') return String(message);
  return Object.values(message)
    .reduce((lines, rules) => lines.concat(collectTexts(rules)), [])
    .join(' · ');
}

export function fieldErrors(message) {
  if (!message || typeof message !== 'object' || Array.isArray(message)) return {};
  const out = {};
  Object.keys(message).forEach((key) => {
    const text = collectTexts(message[key]).join(' · ');
    if (text) out[key] = text;
  });
  return out;
}
